/** @typedef { 'MEMBER' | 'EMPLOYEE' } MemberSiteLogonType */
/**
 * @type {Record<MemberSiteLogonType, number>}
 * @description 會員網站登入類型
 * */
export const MEMBER_SITE_LOGON_TYPE = Object.freeze({
    MEMBER  : 1,   // 會員
    EMPLOYEE: 2,   // 教練
});

export const THEME_TYPE = Object.freeze({
    DEFAULT: 0,
    DARK   : 1,
});

export const HEADER_TYPE = Object.freeze({
    DEFAULT        : 0,
    LOGO_CENTER    : 1,
    LOGO_WHITE     : 2,
    HIDE_BACKGROUND: 4,
    HIDE_USER      : 8,
    BLURRED_GLASS  : 16,
    UNFIXED        : 32,
});

export const FOOTER_TYPE = Object.freeze({
    DEFAULT        : 0,
    HIDE           : 1,
    FLEX           : 2,
    HIDE_BORDER_TOP: 4,
    BLURRED_GLASS  : 8,
    HIDE_TEXT      : 16,
});

/**
 * @description 循環訂單變更單內容類型（bitmask，與 Admin EFFECT_CONTENT_TYPE 同值）
 */
export const EFFECT_CONTENT_TYPE = Object.freeze({
    ITEMS      : 2 ** 0,   // 1   商品口味數量
    SHIPPINGDAY: 2 ** 1,   // 2   出貨週期
    RECEIVER   : 2 ** 2,   // 4   收件資訊
    PAYMENT    : 2 ** 3,   // 8   付款資訊
    STOP       : 2 ** 4,   // 16  暫停
    QUIT       : 2 ** 5,   // 32  退訂
    RESTOP     : 2 ** 6,   // 64  回復暫停
    INVOICE    : 2 ** 7,   // 128 發票資訊
    CHANGEITEMS: 2 ** 8,   // 256 LINE-OA 商品口味數量
});

/**
 * @description 點數紀錄類型（對應後端 RewardActionTypeEnum）
 */
export const REWARD_ACTION_TYPE = Object.freeze({
    ACCUMULATE      : 1,   // 累點
    REDEEM          : 2,   // 兌點
    RETURN          : 3,   // 還點
    EXCHANGE        : 4,   // 交換
    RESET           : 5,   // 歸零
    PREPARE_TO_RESET: 6,   // 到期
    UNREDEEMED      : 7,   // 本次不兌換
    ALL             : 99,  // 全部
});

/**
 * @description 兌換狀態（對應後端 RedeemCartStatusEnum）
 */
export const REDEEM_CART_STATUS = Object.freeze({
    UNPROCESSED: 0,   // 尚未兌換
    REDEEMED   : 1,   // 已兌換
    UNREDEEMED : 2,   // 本次不兌換
});

/**
 * @type {Record<'RESULT' | 'EVALUATION' | 'TRANSCRIPT', number>}
 * @description 量身報表頁面TABS
 * */
export const MEASUREMENT_REPORT_TABS = Object.freeze({
	RESULT    : 0, // 量身結果
	EVALUATION: 1, // 身體評估
	TRANSCRIPT: 2, // 成績單
});
